export default __webpack_public_path__ + "static/media/placeholder-produtos-sicc.06a24b59.png";